import React, { useState } from 'react';
import projectData from '../../data/ProjectData.js';
import ProjectOverview from './ProjectOverview';
import ProjectDetail from './ProjectDetail';
import './Project.css';
import { useGPU } from '../../context/GPUContext';


const ProjectGallery = ({ isDetailView, setIsDetailView }) => {
  const [index, setIndex] = useState(0);
  const { hasGPUAcceleration } = useGPU();
  const handleChange = (newIndex) => {
    if (newIndex < 0 || newIndex >= projectData.length || newIndex === index) return;
    setIndex(newIndex);
  };

  const toggleDetailView = () => {
    setIsDetailView((prev) => !prev);
  };

  const exitDetailView = () => {
    setIsDetailView(false);
  
    requestAnimationFrame(() => {
      const section = document.getElementById('projects');
      if (section) {
        section.scrollIntoView({ block: 'start' });
      }
    });
  };
  

  return (
    <section className="project-gallery" id="projects">
      {isDetailView && projectData[index] ? (
        <ProjectDetail
          {...projectData[index]}
          index={index}
          total={projectData.length}
          onBack={exitDetailView}
          onNext={() => handleChange(index + 1)} 
          gpuEnabled={hasGPUAcceleration}
        />
      ) : (
        <ProjectOverview
          {...projectData[index]}
          index={index}
          total={projectData.length}
          onNext={() => handleChange(index + 1)}
          onPrev={() => handleChange(index - 1)}
          onEnterDetail={toggleDetailView}
          gpuEnabled={hasGPUAcceleration}
        />
      )}
    </section>
  );
};

export default ProjectGallery;
